import { render, staticRenderFns } from "./_ClientDialog.vue?vue&type=template&id=78a33af8"
import script from "./_ClientDialog.vue?vue&type=script&lang=js"
export * from "./_ClientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports